import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { memo, useEffect, useState } from "react";
import PropriedadeDataset from "../data/PropriedadeDataSet";
import Propriedade from "../classes/Propriedade";
import { hasInCache } from "../../helper/cacheHelper";
import { useTranslation } from "react-i18next";

function AutocompletePropriedade(props: AutocompletePropriedadeProps) {
    const { t } = useTranslation();
    const dataSet = new PropriedadeDataset();
    const [data, setData] = useState<Propriedade[]>([]);
    const [dataFilter, setDataFilter] = useState<Propriedade[]>([]);

    useEffect(() => {      
            dataSet.ListarAtivos().then((result) => {                
                setData(result);
            });      
    }, [])


    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1)
            localStorage.setItem("ParametroSel", String(dataFilter[0].descricao));
        else
            if (dataFilter.length !== 1)
                localStorage.removeItem("ParametroSel");
    }, [dataFilter])


    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.descricao.startsWith(event.target.value)))
    }

    return (
        <>
            <Autocomplete
                freeSolo
                id="autocompletePropriedade"
                disableClearable
                options={data.map((option: any) => option.descricao)}
                onChange={(e) => { setDataFilter(data.filter(f => (f.descricao) === String(e.currentTarget.textContent))); }}
                renderInput={(params) => (<TextField
                    {...params}
                    label={t("common.autoComplete.propriedade.label")}
                    InputProps={{
                        ...params.InputProps,
                        type: 'search',
                    }}
                    onChange={handlerOnChange}
                />
                )}
                disabled = {props.disabled}
                value = {props.valorInicial === "" ? null : props.valorInicial}
            />
        </>
    )
}

interface AutocompletePropriedadeProps {
     valorInicial: String,
     disabled: boolean
}

export default memo(AutocompletePropriedade);
